// 평가 관리 화면의 '목록 → 상세' 를 브라우저 뒤로가기와 묶는다 (2026-10-30 Jin).
//   상세가 열리면 history 에 한 칸(evalDetail=key)을 쌓고, 뒤로가기(popstate)로 그 칸을 벗어나면 close().
//   화면 안 '‹ 목록' 버튼은 반환된 back() — 쌓은 칸이 있으면 history.back() 으로 되돌려 기록이 남지 않게 한다.
//   EvalScreen(useEvalState.navTo)은 같은 탭 안에서 오더 패널을 여닫을 때 evalDetail 을 이어 받아,
//   패널을 닫고 뒤로가기를 눌러도 상세가 먼저 닫히지 않는다.
// key: 화면마다 고유 문자열 · open: 상세가 열려 있는지 · close: 목록으로 되돌리는 함수
import { useEffect, useRef } from 'react';

function inDetail(key) {
  var st = window.history.state;
  return !!(st && st.evalDetail === key);
}

function useDetailHistory(key, open, close) {
  var closeRef = useRef(close);
  closeRef.current = close;
  useEffect(function() {
    if (!open) return undefined;
    if (!inDetail(key)) window.history.pushState(Object.assign({}, window.history.state, { evalDetail: key }), '');
    var onPop = function(e) { if (!(e.state && e.state.evalDetail === key)) closeRef.current(); };
    window.addEventListener('popstate', onPop);
    return function() { window.removeEventListener('popstate', onPop); };
  }, [open, key]);
  return function back() {
    if (inDetail(key)) window.history.back();
    else closeRef.current();
  };
}

export default useDetailHistory;
